import { render, staticRenderFns } from "./PersonnelBase.vue?vue&type=template&id=0b773886&scoped=true&"
import script from "./PersonnelBase.vue?vue&type=script&lang=js&"
export * from "./PersonnelBase.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelBase.vue?vue&type=style&index=0&id=0b773886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b773886",
  null
  
)

export default component.exports